import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { PharmaceuticalFormsCard } from '../components'

export const PharmaceuticalFormsPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.pharmaceutical_form.title')
        }
      ]}
      title={t('medicine_register.pharmaceutical_form.title')}
    >
      <PharmaceuticalFormsCard />
    </PageBreadcrumbs>
  )
}
